/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ clause: NonNullable<unknown> }} Filter_Chip_RemoveInputs */

const en_filter_chip_remove = /** @type {(inputs: Filter_Chip_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove filter ${i?.clause}`)
};

const de_filter_chip_remove = /** @type {(inputs: Filter_Chip_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Filter ${i?.clause} entfernen`)
};

/**
* | output |
* | --- |
* | "Remove filter {clause}" |
*
* @param {Filter_Chip_RemoveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_chip_remove = /** @type {((inputs: Filter_Chip_RemoveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Chip_RemoveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_chip_remove(inputs)
	return en_filter_chip_remove(inputs)
});